import React from 'react';
import ServiceSchedulerView from './ServiceSchedulerView';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType, SFNotification } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import { withNotification } from 'common/withNotification';

class ServiceSchedulerContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      service: null,
      hasFetched: false
    };
  }

  componentDidMount() {
    const { id } = this.props;
    const URL = `../api/starfish/success-network/services/${id}`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(service => this.setState({service}))
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return <ServiceSchedulerView {...this.state} {...this.props} />;
  }
}

ServiceSchedulerContainer.propTypes = {
  id: SFEntityID.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  partyId: SFEntityID.isRequired,
  notification: SFNotification.isRequired,
  userTimeZone: PropTypes.string.isRequired
};

export default withNotification(ServiceSchedulerContainer);
